/* Optional cart/drawer display only. Never changes forms, cart properties or checkout. */
(() => {
  'use strict';
  if (window.PMVPreorderCartPresentation) return;
  let guard, copy;
  try {
    guard = JSON.parse(document.getElementById('pmv-preorder-guard-bootstrap').textContent);
    copy = JSON.parse(document.getElementById('pmv-preorder-cart-copy').textContent);
  } catch (_) { return; }
  const key = value => String(value || '').split('/').pop();
  const scope = new Set((guard.scope || []).map(row => key(row.variantId)));
  if (!scope.size || ![copy.payment, copy.cancellation, copy.summary, copy.paymentLabel, copy.cancellationLabel, copy.releaseLabel, copy.shippingLabel].every(value => typeof value === 'string' && value.trim()) || !/^[0-9a-f]{8}$/.test(copy.policyFingerprint || '')) return;
  const selector = '.cart-item [data-pmv-preorder-cart-property]';
  const owned = '[data-pmv-preorder-cart-presentation]';
  const marker = 'data-pmv-cart-ready';
  const records = new Map();
  const datePattern = '(?:January|February|March|April|May|June|July|August|September|October|November|December) (?:[1-9]|[12][0-9]|3[01]), [0-9]{4}';
  const dated = new RegExp('^(' + datePattern + ')\\. Estimated Shipping Date: (' + datePattern + ')\\.$');
  let frame = 0, stopped = false;

  function calendarDate(value) {
    const [month, dayText, yearText] = value.replace(',', '').split(' ');
    const index = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].indexOf(month);
    const day = Number(dayText), year = Number(yearText);
    const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    return year > 0 && day > 0 && day <= [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][index];
  }
  function dates(label, text, normalizedDisplay = false) {
    const normalized = text.replace(/\s+/g, ' ').trim();
    const match = label === 'Release Date:' && normalized.match(dated);
    if (match && calendarDate(match[1]) && calendarDate(match[2])) return [[copy.releaseLabel, match[1]], [copy.shippingLabel, match[2]]];
    if (label === 'Estimated Shipping Date:' && normalized === 'To be confirmed.') return [[copy.shippingLabel, 'To be confirmed']];
    if (normalizedDisplay) {
      if (label === 'Estimated Shipping Date:' && normalized === 'To be confirmed') return [[copy.shippingLabel, 'To be confirmed']];
      if (new RegExp('^' + datePattern + '$').test(normalized) && calendarDate(normalized)) {
        if (label === 'Release Date:') return [[copy.releaseLabel, normalized]];
        if (label === 'Estimated Shipping Date:') return [[copy.shippingLabel, normalized]];
      }
      if (label === 'Payment:' && normalized === 'Charged in full today. Ships when stock arrives.') return [[copy.paymentLabel, text]];
      if (label === 'Cancellation:' && normalized === 'Email us before shipment. Full refund within 24 hours; 10% fee afterward.') return [[copy.cancellationLabel, text]];
    }
    return null;
  }
  function fingerprint(value) {
    let result = 2166136261;
    for (const character of value.replace(/\s+/g, ' ').trim()) result = Math.imul(result ^ character.charCodeAt(0), 16777619) >>> 0;
    return result.toString(16).padStart(8, '0');
  }
  function originalShown(source, ...children) {
    const marked = source.hasAttribute(marker);
    if (marked) source.removeAttribute(marker);
    try {
      return [source, ...children].every(element => {
        const style = getComputedStyle(element);
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' && Number(style.opacity) !== 0;
      });
    } finally { if (marked) source.setAttribute(marker, ''); }
  }
  function restore(source) {
    source.removeAttribute(marker);
    const prior = records.get(source);
    prior?.component.remove();
    // Section clones can contain a prior component without this Map's identity.
    while (source.nextElementSibling?.matches(owned)) source.nextElementSibling.remove();
    records.delete(source);
  }
  function termValue(component, label, value) {
    const term = document.createElement('dt'); term.textContent = label;
    const detail = document.createElement('dd'); detail.textContent = value;
    component.append(term, detail);
  }
  function buildDate(rows) {
    const component = document.createElement('div');
    component.className = 'pmv-preorder-cart-dates';
    for (const [label, value] of rows) termValue(component, label, value);
    return component;
  }
  function buildPolicy(source, label, open, fullOnly = false) {
    const component = document.createElement('div');
    component.className = 'pmv-preorder-cart-policy';
    const term = document.createElement('dt'); term.className = 'visually-hidden'; term.textContent = label;
    const detail = document.createElement('dd');
    for (const [label, value] of (fullOnly ? [] : [[copy.paymentLabel, copy.payment], [copy.cancellationLabel, copy.cancellation]])) {
      const line = document.createElement('p');
      const title = document.createElement('strong'); title.textContent = label + ': ';
      line.append(title, document.createTextNode(value)); detail.append(line);
    }
    const disclosure = document.createElement('details'); disclosure.open = !!open;
    const summary = document.createElement('summary'); summary.textContent = copy.summary;
    const full = document.createElement('div'); full.className = 'pmv-preorder-cart-policy__full';
    for (const child of source.childNodes) full.append(child.cloneNode(true));
    if (full.innerHTML !== source.innerHTML || !full.textContent.trim()) throw new Error('Policy clone incomplete');
    disclosure.append(summary, full); detail.append(disclosure); component.append(term, detail);
    return component;
  }
  function update(source) {
    if ((!scope.has(key(source.dataset.pmvPreorderVariant)) && source.getAttribute('data-pmv-preorder-cart-admitted') !== 'true') || !source.matches(selector)) { restore(source); return; }
    const children = [...source.children];
    const term = children.length === 2 && children[0].tagName === 'DT' ? children[0] : null;
    const value = children.length === 2 && children[1].tagName === 'DD' ? children[1] : null;
    if (!term || !value || term.children.length || value.children.length || !originalShown(source, term, value)) { restore(source); return; }
    const label = term.textContent.trim(), text = value.textContent;
    const normalizedDisplay = source.getAttribute('data-pmv-preorder-display-version') === '1';
    const rows = dates(label, text, normalizedDisplay);
    const policy = label === 'Preorder policy:' && fingerprint(text) === copy.policyFingerprint;
    if (!rows && !policy) { restore(source); return; }
    const signature = source.innerHTML + source.dataset.pmvPreorderVariant + String(normalizedDisplay);
    const prior = records.get(source);
    if (prior?.signature === signature && prior.component.previousElementSibling === source) return;
    const open = prior?.component.querySelector('details')?.open;
    restore(source);
    let component;
    try {
      component = rows ? buildDate(rows) : buildPolicy(value, term.textContent, open, normalizedDisplay);
      component.setAttribute('data-pmv-preorder-cart-presentation', '');
      source.insertAdjacentElement('afterend', component);
      if (component.previousElementSibling !== source) throw new Error('Cart display insertion incomplete');
      records.set(source, { component, signature });
      source.setAttribute(marker, '');
    } catch (_) { component?.remove(); restore(source); }
  }
  function reconcile() {
    frame = 0;
    if (stopped) return;
    for (const source of records.keys()) if (!source.isConnected || !source.matches(selector)) restore(source);
    for (const source of document.querySelectorAll(selector)) {
      try { update(source); } catch (_) { restore(source); }
    }
  }
  function schedule() { if (!stopped && !frame) frame = requestAnimationFrame(reconcile); }
  function insideOwn(node) {
    const element = node?.nodeType === 1 ? node : node?.parentElement;
    return !!element?.closest(owned);
  }
  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => {
      if (insideOwn(mutation.target)) return false;
      if (mutation.type !== 'childList') return true;
      const changed = [...mutation.addedNodes, ...mutation.removedNodes];
      return mutation.removedNodes.length > 0 || !changed.length || !changed.every(node => node.nodeType === 1 && node.matches(owned));
    })) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'data-pmv-preorder-variant', 'data-pmv-preorder-cart-property', 'data-pmv-preorder-display-version', 'data-pmv-preorder-cart-admitted'] });
  window.PMVPreorderCartPresentation = {
    refresh: schedule,
    destroy() { stopped = true; cancelAnimationFrame(frame); observer.disconnect(); for (const source of [...records.keys()]) restore(source); delete window.PMVPreorderCartPresentation; }
  };
  schedule();
})();
